import { TypePlayKitBundleOffer } from '@/lib/api/productCatalog/types';

function sortNumericsDescending(a: number, b: number) {
  return b - a;
}

export function determineMaxSavings(bundles: TypePlayKitBundleOffer[]) {
  if (bundles.length === 0) return 0;

  const [maxBundleSavingsAmount] = bundles
    .map((bundle) => bundle.amount)
    .sort(sortNumericsDescending);

  return Math.ceil(maxBundleSavingsAmount);
}
